import React from 'react';

import { Link } from 'react-router-dom';

import { RoundedIconAnimated } from '@src/components/atoms/rounded-icon-animated';
import { Paragraph8 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledIconTextLinkRounded } from './styles';

const b = bemClassName('icon-text-link-rounded');

const IconTextLinkRounded = ({ icon, text, link, iconSize, ariaLabel }) => {
  return (
    <StyledIconTextLinkRounded>
      <Link to={link} className={b()} aria-label={ariaLabel}>
        <RoundedIconAnimated size={iconSize}>{icon}</RoundedIconAnimated>
        <div className={b('text')}>
          <Paragraph8>{text}</Paragraph8>
        </div>
      </Link>
    </StyledIconTextLinkRounded>
  );
};

export default IconTextLinkRounded;
